module.exports = __webpack_public_path__ + "static/0023-828b908adc98347be018c274287d0022.png";